module.exports = __webpack_public_path__ + "static/media/smoothsole-2.c900849b.jpg";